import React from 'react';
import { Button, IconButton, TextInput, VerifiedDefaultIcon } from '@ntuctech/tangram-web';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { PWL_CONNECTION_SMS, PWL_CONTACT_SMS } from '../../../services/api/constants';
import { fetcherApiRoute } from '../../../services/api/fetcher';
import { startPasswordless } from '../../../services/profile';

import {
  checkSameAsMyinfoAndVerified,
  handleCancel,
  parseMobileInputDisplay,
  updateMiCallbackUiAfterSave,
} from './helperFunction';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 100%;
`;

const VerifyButtonSc = styled(Button)`
  margin-left: 1rem;
`;

const MobileInputSc = styled.div`
  margin-top: 1.25rem;
`;

const commonTrackingParams = {
  screenName: 'account | myinfo onboarding verification',
  previousScreenName: 'account | authentication',
  screenSection: 'widget | myinfo edit mobile number',
  previousScreenSection: null,
  buttonType: 'navigational style',
};

const MobileInput = ({
  setValue,
  value,
  handleCloseSideSheet,
  setToggleView,
  setEditableFlowError,
  userData,
  myinfoData,
  setMyinfoData,
  keyValue,
  setShowToast,
  isPersonaEnabled,
  flowType,
  trackSegment,
  getSegmentUtmParams,
  isMyinfoFapiEnabled,
}) => {
  const { phone_number, phone_number_last_verified } = userData || {};
  const checkValidMobile = new RegExp(/^[89]\d{7}$/i);
  const [inputError, setInputError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [hasEdited, setHasEdited] = React.useState(false);
  const router = useRouter();
  const { query } = router;
  const getUtmParam = getSegmentUtmParams && getSegmentUtmParams(query);

  const handleVerify = () => {
    const trimValue = value.replace(/\s/g, '');
    const editedDiffMobile = hasEdited && trimValue !== phone_number;
    const editedLpMobileUnverified =
      hasEdited && trimValue === phone_number && !phone_number_last_verified;

    if (flowType === 'myinfo') {
      const trackingParams = {
        ...commonTrackingParams,
        buttonName: 'myinfo verify',
      };
      trackSegment && trackSegment('Button Clicked', trackingParams, getUtmParam);
      startPasswordless(
        PWL_CONNECTION_SMS,
        trimValue,
        () => setToggleView('otp'),
        () => setEditableFlowError(true),
        () => setLoading(false),
      );
    } else if (editedDiffMobile || editedLpMobileUnverified) {
      startPasswordless(
        PWL_CONTACT_SMS,
        trimValue,
        () => setToggleView('otp'),
        () => setEditableFlowError(true),
        () => setLoading(false),
      );
    } else {
      fetcherApiRoute(
        /* eslint-disable */
        isMyinfoFapiEnabled
          ? '/api/v2/myinfo-personaldetails-fapi'
          : isPersonaEnabled
          ? '/api/v2/myinfo-update-personaldetails'
          : '/api/myinfo-update-personaldetails',
        {
          method: 'POST',
          body: JSON.stringify({
            value: trimValue,
            field: 'mobileno',
            sessionId: myinfoData.session_id,
          }),
        },
      )
        .then(() => {
          updateMiCallbackUiAfterSave({
            myinfoData,
            setMyinfoData,
            newValue: value,
            key: keyValue,
            handleCloseSideSheet,
            setShowToast,
          });
        })
        .catch(() => {
          setEditableFlowError(true);
        })
        .finally(() => {
          setHasEdited(false);
          setLoading(false);
        });
    }
  };

  const handleOnChange = (e) => {
    setHasEdited(true);
    const parsedValue = parseMobileInputDisplay(e.target.value);
    setInputError(
      checkValidMobile.test(parsedValue.replace(/\s/g, ''))
        ? ''
        : 'Mobile number should start with 8 or 9 and contain 8 digits',
    );
    setValue(parsedValue);
  };

  return (
    <MobileInputSc>
      <TextInput
        label={'Mobile number'}
        description={'A 6-digit OTP will be sent to this mobile number.'}
        value={value}
        onChange={handleOnChange}
        error={inputError}
        required
        suffix={
          checkSameAsMyinfoAndVerified(value, phone_number, keyValue) && (
            <IconButton size="m">
              <VerifiedDefaultIcon />
            </IconButton>
          )
        }
      />
      <ButtonWrapper>
        <Button
          variant="secondary"
          onClick={() => {
            handleCancel({
              flowType,
              commonTrackingParams,
              trackSegment,
              getUtmParam,
              handleCloseSideSheet,
            });
          }}
        >
          Cancel
        </Button>
        <VerifyButtonSc
          variant="primary"
          onClick={handleVerify}
          disabled={inputError.length > 0}
          loading={loading}
        >
          {checkSameAsMyinfoAndVerified(value, phone_number, keyValue) ? 'Save' : 'Verify'}
        </VerifyButtonSc>
      </ButtonWrapper>
    </MobileInputSc>
  );
};

export default MobileInput;
